<template>
  <button @click="modalActive = true" class="w-52 absolute top-4 md:top-10 -right-7 md:right-0">
    <slot />
  </button>

  <vue-modal v-model="modalActive" @close="modalActive = false">
    <div class="modal-content max-w-xs! sm:max-w-lg! items-center! text-center! py-10!">
      <img :src="imageSrc" alt="What's protein coffee" width="288" height="163" class="w-60 sm:w-72" />
      <h1 class="h1">
        What’s Protein Coffee?
      </h1>
      <p class="sm:text-lg px-4">
        We want to make more than oatmeal (even if it is the best oatmeal in the world). So, we surveyed our customers, 
        and almost all of them drink coffee. And of the people who do, most of them want more protein in it. Here we are.
        <br><br>
        Each serving has 5g of protein and 100mg of caffeine. If you love our products, you’ll love this.
      </p>
    </div>
  </vue-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
export interface Props {
  imageSrc: string;
}

const modalActive = ref(false)
defineProps<Props>()
</script>
